/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, OutlinedInput, Stack, Typography } from '@mui/material';
import { LanguageContext } from '../../../libs/Context';
import { getMeetingVerification } from '../../actions/meeting_actions';
import { catchErr } from '../../../libs/HelperContent';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import { toast } from 'react-toastify';

interface MeetingDetails {
	userName : string;
	meetingUrl : any;
}

interface Password {
	open : boolean;
	value : string;
}

interface Query {
	meetingId : string;
	password? : string;
}
const MeetingJoin = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { handleClosePopup, openTime, heading, acceptBtn,
		meetingId, from, handleConfirm, isPassword } = props;

	const [ meetingDetails, setMeetingDetails ] = useState<MeetingDetails>({
		userName   : '',
		meetingUrl : from === 'join' ? meetingId : ''
	});
	const [ password, setPassword ] = useState<Password>({
		open  : isPassword ?? false,
		value : ''
	});
	const [ loading, setLoading ] = useState<boolean>(false);
	const { userName, meetingUrl } = meetingDetails;
	const navigate = useNavigate();
	const userData = useSelector((state:any) => state?.mysession?.session);

	const handleClose = () =>
	{
		handleClosePopup();
	};

	const handleChange = (key, e) =>
	{
		const inputValue = e.target.value.replace(/^\s+/, '');

		setMeetingDetails((prev) => ({
			...prev,
			[key] : inputValue
		}));
	};

	const passwordVerification = (data) =>
	{
		if (data?.isMeetingProtected)
		{
			setPassword((prev) => ({ ...prev, open: true }));
		}
		else
		{
			handleClose();
			const encodedMeetingId = window.btoa(data?._id);
			const encodedEmail = window.btoa(userData?.email);
			const passwordParam = password?.open ? `&password=${Boolean(password?.open)}` : '';

			const meetingUrlLink = `/meetingvc/join/${encodedMeetingId}?email=${encodedEmail}&name=${userName}${passwordParam}`;

			navigate(meetingUrlLink);
		}
	};

	const handleJoinMeeting = async () =>
	{
		setLoading(true);
		const query: Query = {
			meetingId : meetingUrl
		};

		if (password?.value)
		{
			query.password = password?.value;
		}

		try
		{
			const res = await getMeetingVerification(query);

			if (res?.status)
			{
				setLoading(false);
				if (from === 'join')
				{
					handleConfirm();
				}
				else
				{
					passwordVerification(res?.data);
				}
			}
			else
			{
				setLoading(false);
			}
		}
		catch (err:any)
		{
			setLoading(false);
			// eslint-disable-next-line no-console
			console.log(err, '====================>');
			if (err?.response?.data?.error === 'No meeting is there with the given id')
			{
				toast.error(language.enterValidMeetingId, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
			}
			else
			{
				catchErr(err);
			}
		}
	};

	const handleNext = () =>
	{
		if (from === 'share')
		{
			handleConfirm();
		}
		else
		{
			handleJoinMeeting();
		}
	};

	const btnEnable = password?.open ? password?.value === '' : (meetingUrl === '' || userName === '');

	return (
		<Dialog
			open={openTime}
			onClose={handleClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			{loading && <Loading />}
			<DialogTitle id='alert-dialog-title'>
				<Grid container justifyContent={'space-between'} alignItems={'center'}>
					<Grid item>
						<Typography variant='h6' fontWeight='var(--font500)' color='var(--screenShare)'>
							{heading}
						</Typography>
					</Grid>
					<Grid item onClick={handleClose} className='pointer'>
						<RxCross2/>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent>
				{password?.open
					? (
						<Grid item pt='var(--pixel8)'>
							<Typography >
								{language?.password}
							</Typography>
							<FormControl sx={{ p: '8px 0px' }} variant='outlined'
								fullWidth
							>
								<OutlinedInput
									id='outlined-adornment-weight'
									size='small'
									aria-describedby='outlined-weight-helper-text'
									inputProps={{
										'aria-label' : 'weight'
									}}
									placeholder={language?.enterPass}
									value={password?.value}
									onChange={(e) => setPassword((prev) => ({ ...prev, value: e.target.value.replace(/^\s+/, '') }))}
								/>
							</FormControl>
						</Grid>
					)
					: (
						<Grid container flexDirection={'column'} >
							<Grid item pt='var(--pixel8)'>
								<Typography >
									{language?.name}*
								</Typography>
								<FormControl sx={{ p: '8px 0px' }} variant='outlined'
									fullWidth
								>
									<OutlinedInput
										id='outlined-adornment-weight'
										size='small'
										aria-describedby='outlined-weight-helper-text'
										inputProps={{
											'aria-label' : 'weight'
										}}
										placeholder={language.enterYourName}
										value={userName}
										onChange={(e) => handleChange('userName', e)}
									/>
								</FormControl>
							</Grid>
							<Grid item pt='var(--pixel8)'>
								<Typography >
									{meetingId}*
								</Typography>
								<FormControl sx={{ pt: 'var(--pixel8)' }} variant='outlined'
									fullWidth
								>
									<OutlinedInput
										id='outlined-adornment-weight'
										size='small'
										aria-describedby='outlined-weight-helper-text'
										inputProps={{
											'aria-label' : 'weight'
										}}
										placeholder={language.enterMeetingId}
										value={meetingUrl}
										onChange={(e) => handleChange('meetingUrl', e)}

									/>
								</FormControl>
							</Grid>
						</Grid>
					)
				}
			</DialogContent>
			<DialogActions>
				<Stack direction='row' p='var(--pixel16)' alignItems={'center'} display={'flex'}>
					<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='outlined' onClick={handleClose}>
						{language?.cancel}</Button>
					<Typography pl='var(--pixel16)'>
						<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='contained' disabled={btnEnable} className='whiteTxt' onClick={() => handleNext()}>
							{acceptBtn}
						</Button>
					</Typography>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default MeetingJoin;